import { Joyride, STATUS } from "react-joyride";
import { useNavigate } from "react-router-dom";
import { useProfessorUActivityTracker } from "../../hooks/useProfessorUActivityTracker";
import "./AppTour.css";

const TourBeacon = () => (
    <span className="app-tour-beacon">
        <span className="app-tour-beacon__rings" aria-hidden="true">
            <span className="app-tour-beacon__ring" />
            <span className="app-tour-beacon__ring app-tour-beacon__ring--delay" />
        </span>
        <span className="app-tour-beacon__dot" aria-hidden="true" />
        <span className="app-tour-beacon__label">Click here to start page tour</span>
    </span>
);

const AppTour = ({ tourSteps, runTour, setRunTour, callback, goBack = true, tourName, moduleId, activityType, contentId }) => {
    const navigate = useNavigate()
    const { trackTourCompleted } = useProfessorUActivityTracker();

    const defaultCallback = (data) => {
        // console.log("[AppTour event]", data);
        const { status } = data;

        if (callback) {
            callback(data);
        }

        if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
            setRunTour(false);
            if(goBack){
                navigate(-1)
            }
        }

        if (status === STATUS.FINISHED && tourName) {
            trackTourCompleted(tourName, moduleId, activityType, contentId);
        }

    };

    return (
        <Joyride
            steps={tourSteps}
            run={runTour}
            continuous={true}
            scrollToFirstStep={true}
            scrollOffset={20}
            showSkipButton={true}
            showProgress={true}
            beaconComponent={TourBeacon}
            onEvent={defaultCallback}
            floaterProps={{
                disableAnimation: false,
                styles: {
                    floater: {
                        transition: "opacity 0.3s ease",
                    },
                },
            }}
            options={{
                skipScroll: true,
                scrollOffset: 20,
                scrollDuration: 500
            }}
            styles={{
                options: {
                    arrowColor: "#ffffff",
                    backgroundColor: "#1e1e1e",
                    overlayColor: "rgba(0, 0, 0, 0.72)",
                    primaryColor: "#ff6b6b",
                    textColor: "#fff",
                    width: 300,
                    zIndex: 10000,
                },
                spotlight: {
                    stroke: "#f96137",
                    strokeWidth: 3,
                    filter: "drop-shadow(0 0 10px rgba(249, 97, 55, 0.85))",
                },
                tooltip: {
                    width: 300,
                    backgroundColor: "#00067e",
                    color: "#ffffff",
                    borderRadius: 8,
                    padding: 16,
                },
                beaconInner: {
                    backgroundColor: "#ffffff",
                    width: 14,
                    height: 14,
                },

                beaconOuter: {
                    backgroundColor: "#00067e",
                    border: "2px solid #ffffff",
                    width: 36,
                    height: 36,
                },
                arrow: {
                    color: "#00067e",
                },
                buttonClose: {
                    color: "#ffffff",
                },
                buttonPrimary: {
                    backgroundColor: '#f96137',
                    borderRadius: 8,
                },
                buttonBack: {
                    color: '#aeaeae',
                }
            }}
        // callback={(data) => {
        //     if (data.status === "finished" || data.status === "skipped") {
        //         setRunTour(false);
        //     }
        // }}
        />
    )
}

export default AppTour;